import type { ApiSitterSearchConfig, GetSitterSearchConfigRequest } from '@app/packages/internalApi/types'
import { createInternalApiAction, endpoint } from '@app/packages/internalApi/utils'

export const getSitterSearchConfigs = (query: GetSitterSearchConfigRequest) =>
  createInternalApiAction('getSitterSearchConfigs', dispatch =>
    dispatch<{ data: ApiSitterSearchConfig }>({
      method: 'GET',
      endpoint: endpoint('/internal/api/v1/sitter_search_configs', query),
    })
  )
